module.exports = __webpack_public_path__ + "img/Frame.edaa2c16.png";